/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, withState, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { analytics } from 'services/Analytics'
import { withLocalization } from 'hocs/localization'
import { getActivePlan } from 'redux-app/selectors/user'
import { onResendConfirmEmail } from 'redux-app/actionCreators/users'
import { getErrorCodes } from 'utils/error'
import Congrats from './Congrats'

export default compose(
  withLocalization('profile.congrats'),
  connect(
    state => ({
      plan: getActivePlan(state),
    }),
    {
      onResendConfirmEmail,
    },
  ),
  withState('isResendingEmail', 'setResendingStatus', false),
  withHandlers({
    onResend: ({ onResendConfirmEmail, setResendingStatus }) => event => {
      event.preventDefault()
      setResendingStatus(true)
      onResendConfirmEmail()
        .then(() => {
          setResendingStatus(false)
        })
        .catch(error => {
          setResendingStatus(false)
          analytics.showCongratulationsError({ errorCodes: getErrorCodes(error) })
        })
    },
  }),
  lifecycle({
    componentDidMount () {
      const {
        plan,
      } = this.props
            
      window.scrollTo(0, 0)
      analytics.openCreateCongratulationsPage()
      analytics.enrollPlan({ planName: plan.name })
    },
  }),
)(Congrats)
